// extracted by mini-css-extract-plugin
module.exports = {"title":"BlogIndexPage_title__15K8J","articlesList":"BlogIndexPage_articlesList__1OZL3","footer":"BlogIndexPage_footer__m29oY"};